import { Dialog, DialogContent, Button } from '@mui/material';
import CloseOperation from './CloseOperation';
import DialogActionBar from './DialogActionBar';

interface CloseOperationModalProps {
  open: boolean;
  onClose: () => void;
  onCloseOperation: (endDate: string, endTime: string) => Promise<void>;
  endDate: string;
  endTime: string;
  onEndDateChange: (date: string) => void;
  onEndTimeChange: (time: string) => void;
  loading?: boolean;
}

export default function CloseOperationModal({
  open,
  onClose,
  onCloseOperation,
  endDate,
  endTime,
  onEndDateChange,
  onEndTimeChange,
  loading = false
}: CloseOperationModalProps) {
  const isFormValid = () => {
    return endDate.trim() !== '';
  };

  const handleCloseOperation = async () => {
    // Call the parent close handler with end date and time
    try {
      await onCloseOperation(endDate, endTime);
    } catch (error) {
      // Error handling is delegated to the parent component
      console.error('Close operation failed:', error);
    }
  };
  
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: 2,
          width: '600px',
          maxWidth: '600px',
          height: 'auto',
          maxHeight: '90vh',
          pt: 4,
          px: 3,
          pb: 2
        },
      }}
    >
      <DialogContent sx={{ p: 0, mb: 3 }}>
        <CloseOperation
          title="Close Operation?"
          endDate={endDate}
          endTime={endTime}
          onEndDateChange={onEndDateChange}
          onEndTimeChange={onEndTimeChange}
        />
      </DialogContent>

      <DialogActionBar paddingRight={0} >
        <Button onClick={onClose} variant="outlined" size="medium">
          Cancel
        </Button>
        <Button 
          onClick={handleCloseOperation} 
          variant="contained" 
          size="medium"
          disabled={loading || !isFormValid()}
        >
          {loading ? 'Closing...' : 'Close Operation'}
        </Button>
      </DialogActionBar>
    </Dialog>
  );
}